export const CLEAR_REVIEWER_TERMS = 'CLEAR_REVIEWER_TERMS';
export const SEND_REVIEWER_MESSAGE = 'SEND_REVIEWER_MESSAGE';
export const FETCH_REVIEWER_TERM = 'FETCH_REVIEWER_TERM';
export const FETCH_REJECTED_TERMS = 'FETCH_REJECTED_TERMS';
export const FETCH_APPROVED_TERMS = 'FETCH_APPROVED_TERMS';
export const REJECT = 'REJECT';
export const APPROVE = 'APPROVE';
export const FETCH_TO_BE_REVIEWED_TERMS = 'FETCH_TO_BE_REVIEWED_TERMS';